import { Spacing } from '.';
import { tokens } from '../components/crop-circle/tokens';
import { themedStyleSheet } from '../themes/themedStyleSheet';

export const formStyles = themedStyleSheet((role) => ({
  formItem: {
    paddingHorizontal: Spacing.basePadding.paddingHorizontal,
    paddingVertical: Spacing.smallPadding.paddingVertical,
    backgroundColor: role.surface,
    marginBottom: 4,
  },
  // Both titles need an explicit colour. A react-native-web <Text> whose style
  // omits `color` keeps the library's base class, which hardcodes black, so an
  // unset colour is not "inherit the theme" - it is literally black.
  formItemTitle: {
    ...tokens.typography.body.small,
    fontWeight: '600',
    marginBottom: 8,
    color: role.textStrong,
  },
  formItemTitleCropCircle: {
    ...tokens.typography.body.small,
    fontWeight: '600',
    marginBottom: 4,
    color: role.textStrong,
  },
}));
